import Fields from "./BrownieCalculatorFields";
import Result from "./BrownieCalculatorResult";
import calculate from "./calculate";
import Custom from "../customCalculator/CustomCalculatorFormContainer";

const BrownieCalculator = { Fields, Result, Custom, calculate };

export default BrownieCalculator;
